import usePrivateAxios from '@/common/api/usePrivateAxios';
import { ErrorResponse } from '@/common/types/errorResponse';
import { useMutation, UseMutationOptions } from '@tanstack/react-query';

interface UseMaintenanceEstablishmentChoiceAuctionEntryProposalsAcceptProps {
  proposalId: string | undefined;
  options?: Partial<Omit<UseMutationOptions<
    unknown,
    ErrorResponse
  >, 'mutationKey' | 'mutationFn'>>;
}

export const useMaintenanceEstablishmentChoiceAuctionEntryProposalsAccept = ({
  proposalId,
  options,
}: UseMaintenanceEstablishmentChoiceAuctionEntryProposalsAcceptProps) => {
  const privateAxios = usePrivateAxios();

  return useMutation({
    mutationKey: ['maintenanceEstablishmentChoiceAuctionEntryProposalsAccept'],
    mutationFn: () => {
      return privateAxios.put(`/maintenance/establishment_choice/auction_entry_proposals/${proposalId}/accept`);
    },
    ...options
  });
}
